export default class PollingManager {
  constructor(url, options = {}) {
    this.url = url
    this.maxRetries = options.maxRetries ?? Infinity
    this.interval = options.interval ?? 5000
    this.emit = options.emit ?? (() => {})
    this.debug = options.debug ?? false
    this.intervalRef = undefined

    this.retryCount = 0
    this.start()
  }

  /**
   * Initiates the polling mechanism, which will repeatedly send requests to the
   * specified URL at defined interval until a successful response is received
   * or max retries is reached.
   */
  start() {
    this.intervalRef = setInterval(async () => {
      try {
        // Max retries reached, stop polling
        if (this.retryCount >= this.maxRetries) {
          this._log(`Max retries reached. Stopping polling to ${this.url}`)

          clearInterval(this.interval)
          return
        }

        this._log(`Polling ${this.url} (Attempt ${this.retryCount + 1})`)

        // Polling request
        const response = await fetch(this.url)

        // Ok response, emit data and stop polling
        if (response.ok) {
          const data = await response.json()

          // Stop polling if data is received
          clearInterval(this.intervalRef)
          this.emit('message', JSON.stringify(data))
        }
      } catch (error) {
        this.retryCount++

        this._log(`Request error: ${error}`)
      }
    }, this.interval)
  }

  stop() {
    if (this.intervalRef) clearInterval(this.intervalRef)
  }

  _log(message) {
    if (this.debug) {
      // eslint-disable-next-line no-console
      console.log(`[PollingManager] ${message}`)
    }
  }
}
